import React, { useState } from "react";
import { cn } from "@/lib/utils";
import { useUpdateLayerIcons } from "api";
import { Row } from "@tanstack/react-table";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { LayerIcon } from "../types";

interface DataTableRowProps {
  row: Row<LayerIcon>;
  entityKey: string;
  type?: string;
}

export const DataTableRowText = ({
  row,
  entityKey,
  type,
}: DataTableRowProps) => {
  const data = row.original;

  const { handleUpdate, isMutating } = useUpdateLayerIcons(data.id);

  const [text, setText] = useState(data[entityKey] || "");
  const [isOpen, setIsOpen] = useState(false);

  const disabled = !text || isMutating || data[entityKey] === text;
  const onSubmit = () => {
    if (disabled) {
      return null;
    }
    handleUpdate(entityKey, text, false);
    setIsOpen(false);
  };

  return (
    <div className="max-w-[500px] min-w-[130px] flex flex-col gap-2">
      <Dialog open={isOpen} onOpenChange={(isOpen) => setIsOpen(isOpen)}>
        <DialogTrigger asChild>
          <div
            onClick={() => setIsOpen(true)}
            className={cn(
              "flex h-8 w-full rounded-md border border-transparent bg-transparent px-2 py-1 text-sm transition-colors",
              "hover:outline-none hover:ring-1 hover:ring-ring hover:border-input hover:shadow-sm",
            )}
          >
            {data[entityKey]}
          </div>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Update {entityKey}</DialogTitle>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                {entityKey}
              </Label>
              <Input
                className="col-span-3"
                value={text}
                type={type || "text"}
                onChange={(e) => setText(e.target.value)}
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              disabled={isMutating || !text || text === data[entityKey]}
              onClick={onSubmit}
            >
              Submit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};
